<template lang="">
    <section class="flex flex-col">
        <div class="w-full flex items-end justify-between mb-6">
            <typography variant="p-large" class="font-semibold text-gray-900 dark:text-gray-400">{{ header }}</typography>

            <slot name="additional"/>
        </div>

        <slot/>
    </section>
</template>

<script>
export default {
    props: {
        header: {
            type: String,
            default: ""
        }
    }
}
</script>